import { render, staticRenderFns } from "./ShiftsView.vue?vue&type=template&id=6abb89df&"
import script from "./ShiftsView.vue?vue&type=script&lang=js&"
export * from "./ShiftsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports